import React from 'react';
import utils from '../../../utils';
import './style.scss';

function formatPrice(priceValue) {
    const numeric = parseFloat(String(priceValue).replace(/[^\d.-]/g, ''));
    if (Number.isNaN(numeric)) {
        return '';
    }
    return `AU $ ${numeric.toFixed(2)}`;
}

const TABLE_COLUMNS = ['Single Match', 'Live Feeds Season Pass', 'Adelaide Footy TV'];

const TABLE_ROWS = [
    {
        feature: 'Price',
        cells: [
            { type: 'price', value: 5 },
            { type: 'price', value: 20 },
            { type: 'price', value: 20 },
        ],
    },
    {
        feature: 'Coverage',
        cells: ['One Match', 'Full Season', 'Full Season'],
    },
    {
        feature: 'Watch Matches Live',
        cells: [{ type: 'check' }, { type: 'check' }, { type: 'cross' }],
    },
    {
        feature: 'Full Match Replays',
        cells: [{ type: 'cross' }, { type: 'cross' }, { type: 'check' }],
    },
    {
        feature: "Men's Division 1",
        cells: [
            { type: 'checkText', text: 'One match' },
            { type: 'checkText', text: 'All selected' },
            { type: 'checkText', text: 'If filmed' },
        ],
    },
    {
        feature: 'Other Divisions',
        cells: [{ type: 'cross' }, { type: 'cross' }, { type: 'check' }],
    },
    {
        feature: 'Finals Included',
        cells: [{ type: 'cross' }, { type: 'cross' }, { type: 'check' }],
    },
    {
        feature: 'Access Timing',
        cells: ['Immediate', 'Immediate', 'Within 12 hrs'],
    },
];

function TableCell({ cell }) {
    if (cell === null || cell === undefined) {
        return null;
    }

    if (typeof cell === 'string') {
        return <span className="subscriptionTable__cellValue">{cell}</span>;
    }

    if (cell.type === 'price') {
        return <span className="subscriptionTable__cellValue">{formatPrice(cell.value)}</span>;
    }

    if (cell.type === 'check') {
        return (
            <span className="subscriptionTable__cellValue subscriptionTable__cellValue--icon" aria-label="Included">
                <span className="subscriptionTable__icon subscriptionTable__icon--check" aria-hidden="true">&#10003;</span>
            </span>
        );
    }

    if (cell.type === 'cross') {
        return (
            <span className="subscriptionTable__cellValue subscriptionTable__cellValue--icon" aria-label="Not included">
                <span className="subscriptionTable__icon subscriptionTable__icon--cross" aria-hidden="true">&#10005;</span>
            </span>
        );
    }

    if (cell.type === 'checkText') {
        return (
            <span className="subscriptionTable__cellValue subscriptionTable__cellValue--iconText">
                <span className="subscriptionTable__icon subscriptionTable__icon--check" aria-hidden="true">&#10003;</span>
                <span>{cell.text}</span>
            </span>
        );
    }

    return null;
}

export function SubscriptionTable(props) {
    const item = props.item;
    const cmsOption = props.cmsOption || {};

    const cssClass = utils.classNames('cms_item', 'subscriptionTable', item.cssClass || item.anchorName || '');

    return (
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            <div className="subscriptionTable__wrapper">
                <table className="subscriptionTable__table">
                    <thead>
                        <tr>
                            <th scope="col" className="subscriptionTable__featureCol">Feature</th>
                            {TABLE_COLUMNS.map((column) => (
                                <th scope="col" key={column}>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {TABLE_ROWS.map((row) => (
                            <tr key={row.feature}>
                                <th scope="row" className="subscriptionTable__featureCol">{row.feature}</th>
                                {row.cells.map((cell, index) => (
                                    <td key={index}>
                                        <TableCell cell={cell} />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
